import React from "react";
import heroBg from "../assets/img/about/about_banner.webp";
import { IBannerImage } from "../exports/interfaces";
import { useMobile } from "../hooks/custom/useMobile";

const Banner = (props: {
  title: string;
  bannerImage?: IBannerImage;
  start_background_color?: string;
  end_background_color?: string;
  program?: string;
  course?: string;
}) => {
  const isMobile = useMobile();
  return (
    <>
      <section
        className="td_hero td_banner_style_1 td_heading_bg td_center td_bg_filed"
        style={{
          backgroundImage:
            props.start_background_color && props.end_background_color
              ? `
    linear-gradient(
      130deg,
      ${props.end_background_color}CC 0%,
      ${props.start_background_color} 100%
    ),
    url(${
      props.bannerImage
        ? `${process.env.REACT_APP_cmsUrl}${props.bannerImage?.media?.url}`
        : heroBg
    })
  `
              : `url(${
                  props.bannerImage
                    ? `${process.env.REACT_APP_cmsUrl}${props.bannerImage?.media?.url}`
                    : heroBg
                })`,
          height: "500px",
          backgroundPosition:
            props.bannerImage && isMobile ? "13% center" : "center",
        }}
      >
        <div className="container">
          <div
            className="td_hero_text wow fadeInRight"
            data-wow-duration="0.9s"
            data-wow-delay="0.35s"
          >
            {props.program && props.course && (
              <>
                <p
                  className="td_section_subtitle_up td_fs_18 td_spacing_1 td_mb_10 td_white_color"
                  style={{ marginBottom: 0, marginTop: "150px" }}
                >
                  SAST | Undergraduate Programs | {props.program}
                </p>
                <h2 className="td_hero_title td_fs_36 td_white_color">
                  {props.course}
                </h2>
              </>
            )}
          </div>
        </div>
        <div className="td_lines">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </section>
    </>
  );
};

export default Banner;
